import React from 'react';

import { Box } from '@mui/material';

import Spin from './Spin';
import WhatsappFloatingButton from 'components/WhatsappFloatingButton';
import { useDynamicBackground } from 'hooks/useDynamicBackground';
import { useDynamicLogo } from 'hooks/useDynamicLogo';
import { useDynamicLogoForm } from 'hooks/useDynamicLogoForm';
import {
  OnboardingBackground,
  OnboardingButtonsContainer,
  OnboardingCard,
  OnboardingContainer,
  OnboardingContent,
  OnboardingContentCenter,
  OnboardingContentForm,
  OnboardingFooterButton,
  OnboardingForm,
  OnboardingFormContainer,
  OnboardingImage,
  OnboardingInputsContainer,
  OnboardingLine,
  OnboardingLogo,
  OnboardingModalContent,
  OnboardingNameSurnameContainer,
  OnboardingRememberForgotContainer,
  OnboardingSeparator,
  OnboardingTopButton,
} from 'styles/onboarding';
import { useIsMobile } from 'utils/mediaQueries';

interface OnboardingLayoutProps {
  children: React.ReactNode;
  showLogo?: boolean;
  maxWidth?: string;
  height?: string;
}

export const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  children,
  showLogo = true,
  maxWidth = '441px',
  height = 'max-content',
}) => {
  const {
    mediaUrl: backgroundUrl,
    mediaType: backgroundType,
    isLoading: backgroundLoading,
    error: backgroundError,
  } = useDynamicBackground();
  const { logo, isLoading: logoLoading, error: logoError } = useDynamicLogo();
  const {
    mediaUrl: logoFormUrl,
    isLoading: isLogoFormLoading,
    error: logoFormError,
  } = useDynamicLogoForm();
  const isMobile = useIsMobile();

  // Mostra loading enquanto qualquer um dos recursos estiver carregando
  const isLoading = backgroundLoading || logoLoading || isLogoFormLoading;
  const hasError = backgroundError || logoError || logoFormError;

  if (isLoading) {
    return <Spin size="large" fullscreen />;
  }

  /*  if (hasError) {
    return (
      <div style={{ padding: 32, textAlign: 'center', color: 'red' }}>
        Ocorreu um erro ao carregar os recursos de onboarding.
        <br />
        {backgroundError?.message || logoError?.message || logoFormError?.message}
      </div>
    );
  } */

  const isImage = !!backgroundUrl && backgroundType?.startsWith('image/');
  const isVideo = !!backgroundUrl && backgroundType?.startsWith('video/');
  const hasBackgroundMedia = isImage || isVideo;

  return (
    <>
      <OnboardingBackground background={isImage && !isMobile ? backgroundUrl : undefined}>
        {isVideo && (
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              zIndex: 0,
            }}
            src={backgroundUrl!}
          />
        )}
        <OnboardingContainer>
          <OnboardingContent>
            {!isMobile && (
              <OnboardingCard>
                {!hasBackgroundMedia && showLogo && (
                  <OnboardingImage src={logo || undefined} alt="Logo" />
                )}
              </OnboardingCard>
            )}

            <OnboardingFormContainer maxWidth={maxWidth} height={height}>
              {logoFormUrl && (
                <Box
                  display="flex"
                  justifyContent="center"
                  mb={5}
                  width="100%"
                  height={20}
                  alignItems="center"
                >
                  <img
                    src={logoFormUrl}
                    alt="Logo do formulário"
                    style={{
                      marginTop: '0.5rem',
                      padding: '0.2rem',
                      height: isMobile ? 320 : 120,
                      objectFit: 'scale-down',
                      width: '100%',
                      zIndex: -1,
                    }}
                  />
                </Box>
              )}
              {children}
            </OnboardingFormContainer>
          </OnboardingContent>
        </OnboardingContainer>
      </OnboardingBackground>
      <WhatsappFloatingButton />
    </>
  );
};

export {
  OnboardingBackground,
  OnboardingButtonsContainer,
  OnboardingCard,
  OnboardingContainer,
  OnboardingContent,
  OnboardingContentCenter,
  OnboardingContentForm,
  OnboardingFooterButton,
  OnboardingForm,
  OnboardingFormContainer,
  OnboardingImage,
  OnboardingInputsContainer,
  OnboardingLine,
  OnboardingLogo,
  OnboardingModalContent,
  OnboardingNameSurnameContainer,
  OnboardingRememberForgotContainer,
  OnboardingSeparator,
  OnboardingTopButton,
};
